import React, { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandPointUp, faUserAstronaut, faUserSecret } from '@fortawesome/free-solid-svg-icons';
import { Spinner } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import styles from '../chatBot.module.scss';
import { PAMMState } from '../../redux/reducers/rootReducer';
import CopiedIcon from '../../icons/CopiedIcon';
import CopyIcon from '../../icons/CopyIcon';
import customerPortalIcon from '../../icons/customer-portal-icon-ai.svg';
import BoldMarkdown from '../../components/shared/BoldMarkdown';
import { trackEvent } from '../../utils/trackEvent';
import { ChatRole } from '../../redux/reducers/chatBotReducer';

const WELCOME_MESSAGE = 'message.greeting';

export const Messages = memo(() => {
  const { Messages: messages, SuggestedQuestions, FetchStatus } = useSelector((state: PAMMState) => state.chatBotReducer);
  const customerPortalLink: string = useSelector((state: PAMMState) => state.configReducer.customerPortalLink);

  const [copiedText, setCopiedText] = useState<string | null>(null);

  const handleCopy = async (text: string): Promise<void> => {
    await navigator.clipboard.writeText(text);
    setCopiedText(text);
    setTimeout(() => setCopiedText(null), 2000);
  };

  return (
    <div className={styles['content']}>
      {messages.map((item: { role: string; text: string }) => (
        <div className={item.role === ChatRole.Bot ? styles['msgBot'] : styles['msgUser']} key={item.text}>
          {item.role !== ChatRole.Bot && (
            <FontAwesomeIcon icon={faUserAstronaut} className={styles['svgIcon']} color="var(--black-400)" />
          )}
          {!item.text.includes(WELCOME_MESSAGE) && (
            <span>
              <BoldMarkdown text={item.text} />
            </span>
          )}
          {item.role === ChatRole.Bot &&
            item.text.includes(WELCOME_MESSAGE) &&
            item.text.split('\n').map((part: string, partIndex: number) => (
              <span key={partIndex}>
                {part && <FormattedMessage id={part} />}
                {partIndex < item.text.split('\n').length - 1 && <br />}
              </span>
            ))}
          {item.role === ChatRole.Bot && !item.text.includes(WELCOME_MESSAGE) && (
            <div>
              {/* // TODO next version bot */}
              {/* <div className="d-flex align-items-center mt-2">
                <span>
                  <FormattedMessage id="messages.moreInfo" />
                </span>
                <FontAwesomeIcon icon={faHandPointUp} className={styles['svgIconHand']} />
              </div> */}
              <div className={styles['imageContainer']}>
                <button type="button" onClick={() => handleCopy(item.text)} className={styles['copyButton']}>
                  {copiedText === item.text ? <CopiedIcon color="#DADADA" /> : <CopyIcon color="#DADADA" />}
                </button>
                <a
                  href={customerPortalLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles['customerPortal']}
                  onClick={() => trackEvent('customer_portal', 'customerportalai_button_click')}
                >
                  <img src={customerPortalIcon} alt="customer-portal-icon-ai" />
                  <span>
                    <FormattedMessage id="customerPortal" />
                  </span>
                </a>
              </div>
            </div>
          )}
        </div>
      ))}
      {(FetchStatus.loading || (!SuggestedQuestions?.length && FetchStatus.status === 0)) && (
        <div className={styles['msgBot']}>
          <FontAwesomeIcon icon={faUserSecret} className={styles['svgIcon']} color="var(--black-400)" />
          {[...Array(3)].map((_, index) => (
            <Spinner
              key={index}
              animation="grow"
              size="sm"
              style={{ backgroundColor: '#D9D9D9', marginRight: index < 2 ? '4px' : '0' }}
            />
          ))}
        </div>
      )}
      {FetchStatus.status !== 200 && FetchStatus.status > 0 && (
        <div className={styles['msgBot']} key={FetchStatus.status}>
          <FontAwesomeIcon icon={faUserSecret} className={styles['svgIcon']} color="var(--black-400)" />
          <span>AI chatbot is unavailable, contact PAMM support to fix it.</span>
        </div>
      )}
    </div>
  );
});
